import clsx from "clsx";
import React from "react";
import logo from "assets/logo_gerdau_blue_horizontal.svg?url";
import styles from "./Nav.module.scss";
import { IconColors, SvgIcon } from "common/components";
import { UserMenu } from "./UserMenu";

export const NavComponent: React.FC = () => {
  return (
    <div className={clsx(styles.qqtNav, "d-flex align-items-center bg-white position-fixed")}>
      <div className="flex-fill">
        <a href="/">
          <img
            src={logo}
            alt="Quick Quote Tool Logo"
            className={clsx("m-0 my-10 ms-10", styles.qqtLogo)}
          />
        </a>
      </div>
      <div className={clsx(styles.navRight, "font-size-12")}>
        <a href="/how-to" className={clsx(styles.navLink, "text-decoration-none")}>
          <SvgIcon
            name="info-alert"
            attributes={{ width: "15px", height: "15px", fill: IconColors.PRIMARY }}
          />
          <span>HOW TO</span>
        </a>
        <a href="http://www.egerdau.com" className={clsx(styles.navLink, "text-decoration-none")}>
          <SvgIcon
            name="home"
            attributes={{ width: "18px", height: "15px", fill: IconColors.PRIMARY }}
          />
          <span>eGERDAU</span>
        </a>
        <UserMenu />
      </div>
    </div>
  );
};
